import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { parseMarginOrPadding } from '@helpers'

const propTypes = {
  as: PropTypes.oneOf(['p', 'blockquote', 'span', 'div', 'label', 'li'])
}

const Text = styled.p.attrs((props) => {
  let weight = props.theme.typography.body.fontWeight
  if (props.bold) weight = 700
  if (props.medium) weight = 500
  return {
    as: props.as || 'p',
    color:
      props.theme.palette.text[props.color] ||
      props.color ||
      props.theme.palette.text['200'],
    weight: weight
  }
})`
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  color: ${(props) => props.color};
  font-weight: ${(props) => props.weight};
  font-family: ${(props) => props.theme.typography.body.fontFamily};
  font-size: ${(props) =>
    props.size || props.theme.typography.body.fontSize}rem;
  line-height: ${(props) =>
    props.lineHeight || (props.as == 'p' ? '1.75' : undefined)};
  text-transform: ${(props) =>
    props.uppercase ? 'uppercase' : props.theme.typography.body.case || 'none'};
  letter-spacing: ${(props) =>
    props.spacing ? props.spacing : props.theme.typography.body.spacing}em;
  margin: ${(props) => parseMarginOrPadding(props.margin)};
  padding: ${({ padding }) => parseMarginOrPadding(padding)};
  text-overflow: ${(props) => props.overflow || undefined};
  white-space: pre-wrap;
  ${(props) =>
    props.lines &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${props.lines};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `};

  mark {
    color: ${(props) => props.theme.palette.primary['400']};
    background: none;
    text-decoration: underline;
  }
`

Text.propTypes = propTypes
export default Text
